







































































































































import TallaAdd from "@/components/admin/evento/TallaAdd.vue";
import Vue from "vue";
import ModificarDireccionPedido from "@/components/web/cliente/ModificarDireccionPedido.vue";
import EditInscriptionDialog from "@/components/web/cliente/EditInscriptionDialog.vue";
//import TallaService, { TallaCreateDto } from "@/api/TallaService";
import CarreraService from "@/api/CarreraService";
import AuthStore from "@/store/modules/AuthStore";
import Carrera from "@/views/admin/evento/Carrera.vue";
export default Vue.extend({
  components: {
    ModificarDireccionPedido,
    EditInscriptionDialog,
  },
  metaInfo: {
    title: "Tallas"
  },
  data() {
    return {
      dialog: false,
      dato: {
        nombre: "",
        descripcion: ""
      } as any,
      headers: [
        { text: "#", value: "id" },
        { text: "Fecha Registro", value: "createdOn", sortable: false },
        { text: "Carrera", value: "carrera.nombre" },
        { text: "Persona", value: "persona.nombre" },
        { text: "Distancia", value: "distancia.nombre" },
        //{ text: "# Camiseta", value: "numeroCamiseta" },
        { text: "Talla Camiseta", value: "tallaCamiseta.talla.nombre" },
        { text: "Personalización", value: "personalizacionCamiseta" },
        //{ text: "Tipo Pago", value: "pedido.displayTipoPago" },
        //{ text: "Estado Pago", value: "pedido.displayEstadoPago" },
        //{ text: "Motivo Rechazo", value: "pedido.motivoRechazo" },
        //{ text: "Estado Envio", value: "displayEstadoEnvio" },
        //{ text: "Estado Entrega", value: "displayEstadoEntrega" },
        { text: "Total", value: "pedido.displayTotal" },
        //{ text: "Estado", value: "estado" },
        { text: "Acciones", value: "actions2", sortable: false, align: "center" },
        {
          text: "Estado de Kit",
          value: "kit_status",
          sortable: false,
          align: "center"
        }
      ],
      datos: [] as any[],
      editingInscription: false,
      selectedInscription: null,
    };
  },
  methods: {
    getUserPersonaId() {
      return AuthStore.getPersonaID;
    },
    setDefaultItem() {
      const newDto = {
        nombre: "",
        descripcion: ""
      };
      this.dato = newDto;
    },
    toSubirRecibo(id: string) {
      this.$router.push({
        path: "/proceso-pago/subir-papeleta",
        query: { idPedido: id }
      });
    },
    editItem(item: any) {
      this.dato = item;
      this.dialogChange(true);
    },
    editInscription(inscription: any) {
      this.selectedInscription = inscription;
      this.editingInscription = true;
    },
    onCloseEditInscription() {
      this.editingInscription = false;
      this.selectedInscription = null;
    },
    newItem() {
      this.setDefaultItem();
      this.dialogChange(true);
    },
    dialogChange(value: boolean) {
      this.dialog = value;
    },
    getAll() {
      CarreraService.getMisRegistros()
        .then(response => {
          this.datos = response;
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            icon: "error",
            title: "Registros",
            text: "No se pudo obtener"
          });
        });
    },
    itemIsPaymentPending(item: any) {
      return item?.pedido?.estadoPago === '1';
    },
    itemIsOffTime(item: any) {
      const rawDateDistancias = item?.carrera?.fechaFinEdicionDistancias;
      const rawDateTallas = item?.carrera?.fechaFinEdicionTallas;
      console.log('rawDateDistancias:', rawDateDistancias);
      console.log('rawDateTallas:', rawDateTallas);
      if(!rawDateDistancias || !rawDateTallas) {
        return true;
      }

      if (new Date(rawDateDistancias).getTime() < new Date().getTime() 
          || new Date(rawDateTallas).getTime() < new Date().getTime()) {
        return true;
      }

      return false;
    },
    itemCanBeEdited(item: any) {
      return !this.itemIsOffTime(item)
        && item.estadoEnvio == '1'
        && item.estadoEntrega == '1';
    },
    calculateKitStatus(item: {
      pedido: { estadoPago: string; estadoEntrega: string };
    }) {
      const paymentStatus = item.pedido.estadoPago;
      const deliveryStatus = item.pedido.estadoEntrega;
      if (paymentStatus == "1") {
        return "Pendiente de pago";
      } else {
        switch (paymentStatus) {
          case "2":
            return "Pagado";
          case "3":
            return "Rechazado";
          case "4":
            return "Anulado";
          case "7":
            return "Verificando Papeleta";
        }
      }

      if (deliveryStatus == "1") {
        return "Pendiente de Entrega";
      } else {        
        return "Entregado";
      }
    },
    calculateShirtCustomization(item: {
      carrera: { estadoPersonalizacion: string };
      personalizacionCamiseta: string;
    }) {
      return item.carrera.estadoPersonalizacion == "1"
        ? item.personalizacionCamiseta
        : "No Disponible";
    }
  },
  mounted() {
    this.getAll();
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === false) {
        this.setDefaultItem();
      }
    }
  }
});
